import axios from "axios";

export const duplicatePathApi = (pathId: number) =>
    axios.post(`/api/v1/underwriting/paths/${pathId}/duplicate`);

